<template>
    <div class="addon-product-container">
      <div class="product-image-container" :class="(canAddMore == false && this.currentQty == 0) ? 'disabled' :'available'">
          <img  :src="product | getProductLastImage" >
          <div v-if="canAddMore == false && this.currentQty == 0" class="limit-alert">{{limitMessage}}</div>
          <button v-if="!isMobile" :disabled="canAddMore == false" @click="updateProductQuantity(true)" v-show="currentQty == 0" class="happybox-button yellow">Add to Box</button>
          <div v-if="!isMobile" class="quantity-container" v-show="currentQty > 0">
            <button @click="updateProductQuantity(false)">-</button>
            <p>{{currentQty}} per box</p>
            <button @mouseenter="setButtonHover(true)" @mouseleave="setButtonHover(false)"  v-tooltip="{content: limitMessage, show: shouldHover, trigger: ['manual'], hideOnTargetClick: false}" @click="updateProductQuantity(true)">+</button>
          </div>
      </div>
    </div>
  </template>
  <script>
  import { mapGetters } from 'vuex';
  export default {
      props: {
          product: Object,
          cartProducts: Array,
          boxQty: Number,
      },
      data() {
        return {
          isHovering: false,
          productLimit: 10,
        }
      },
      computed:{
          ...mapGetters([
            'maxCapacity',
            'currentCapacity',
          ]),
          productPrice(){
              return this.product.variants.find(x => x.price != "").price
          },
          hasComparePrice(){
              return this.product.variants.find(x => x.price != "").compare_at_price
          },
          currentQty(){
            if(this.cartProducts){
              var product = this.cartProducts.find(x => x.id == this.product.id);
              if(product)
                return product.quantity
            }
            return 0
          },
          canAddMore(){
            if(this.maxCapacity < (this.currentCapacity + this.product.capacity))
              return false
            if((this.boxQty * (this.currentQty + 1)) > this.product.variants[0].inventory_quantity)
              return false
            if(this.currentQty >= this.productLimit)
              return false
  
            return true
          },
          limitMessage(){
            if(this.maxCapacity < (this.currentCapacity + this.product.capacity))
              return 'Your Box is too full!';
            if((this.boxQty * (this.currentQty + 1)) > this.product.variants[0].inventory_quantity)
              return 'Not enough inventory';
            if(this.currentQty >= this.productLimit)
              return 'Item limit per box'
  
            return ''
          },
          shouldHover(){
            if(this.canAddMore == false && this.currentQty > 0 && this.isHovering == true){
              return true;
            }
            return false;
          },
          hasVariants(){
            return this.product.variants.length > 1;
          },
          isMobile() {
            return window.innerWidth < 768;
          },
      },
      methods:{
        updateProductQuantity(increment){
          if(increment){
            if(this.canAddMore)
              this.$store.commit('updateSelectedAddonProductsNew',{product: this.product, quantity: (this.currentQty + 1)});
          }
          else{
            this.$store.commit('updateSelectedAddonProductsNew', {product: this.product,quantity: (this.currentQty - 1)});
          }
        },
        setButtonHover(state){
          this.isHovering = state;
        }
      },
  }
  </script>
  
  <style scoped>
  .addon-product-container{
    width: auto;
    max-width: 100%;
    height: 100%;
  }
  
  .product-image-container{
    width: auto;
    max-width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    display: flex;
  }
  
  .product-image-container img {
    width: auto;
    max-width: 100%;
    height: 100%;
  }
  
  .product-image-container.disabled img{
    opacity: 0.4;
  }
  
  .limit-alert{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    background-color: white;
    width: 100%;
    position: absolute;
    bottom: 40%;
    font-size: 1vw;
    color: black;
    font-weight: bold;
  }
  
  .happybox-button{
    position: absolute;
    width: 90%;
    bottom: -30%;
    margin: unset;
    transition: all 0.5s ease-in-out;
    left: 5%;
  }
  
  .product-image-container.available:hover .happybox-button{
    bottom: 5%;
  }
  
  .quantity-container{
    position: absolute;
    width: 100%;
    display: flex;
    align-items: stretch;
    justify-content: space-around;
    bottom: 5%;
  }
  
  .quantity-container button{
    display: flex;
    font-size: 2vw;
    width: 15%;
    line-height: 1.15;
    justify-content: center;
    align-items: center;
    background-color: white;
    border: 1px solid #F3EEFA;
    box-shadow: 0px 1px 2px #1f293714;
    border-radius: 4px;
  }
  
  .quantity-container button:hover{
    background-color: #faf7fe
  }
  
  .quantity-container button.has-tooltip{
    opacity: 0.6;
  }
  
  .quantity-container p{
    background: #FFFFFF;
    border: 1px solid #F3EEFA;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 1%;
    width: 50%;
    font-size: 0.8vw;
  }
  
  .product-title{
    font-weight: 700;
    font-size: 0.9vw;
    line-height: 1.5;
    margin-top: 2%;
  }
  
  .product-price-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-size: 0.8vw;
    padding-bottom: 5%;
  }
  
  .product-price-container .price{
    color: #3F3D60;
  }
  
  .product-price-container .discount-price{
    color: red;
    text-decoration: line-through;
    padding-right: 5%;
  }
  
  .main-badge{
    background-color: white;
    position: absolute;
    top: 2%;
    left: 2%;
    border: 1px solid #F3EEFA;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 1% 3%;
    font-size: 1.1vw;
    font-weight: bold;
  }
  
  @media screen and (max-width: 767px){
    .happybox-button{
      position: initial;
      text-transform: uppercase;
      box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
      margin: 3% 0% 3% 5%;
    }
    .quantity-container{
      position: relative;
      margin: 4% 0%;
    }
    .quantity-container button{
      font-size: 2rem;
      line-height: 1.51;
      color: #0F0C38;
      border-radius: 50px;
      height: 3.2rem;
      width: 3.2rem;
    }
  
    .quantity-container p{
      font-size: 1rem;
      color: #0F0C38;
      border: unset;
    }
  
    .product-title{
      font-size: 1rem;
    }
  
    .product-price-container{
      font-size: 1rem;
    }
  
    .main-badge{
      top: unset;
      bottom: 2%;
      font-size: 1rem;
    }
  
    .limit-alert{
      font-size: 3vw;
    }
  }
  
  </style>